import React, { useEffect, useCallback, useState } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";

import NoDataFound from "../../../../../components/ui/NoDataFound";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { dashboardSSLExpiry30DaysIcon, dashboardSSLExpiry60DaysIcon, dashboardSSLExpiry90DaysIcon } from "../../../../../utils/icons";

import { useSelector, useDispatch } from 'react-redux';
import { getBecData, getSSLExpiry } from "../../../../../store/actions/dashboardAction";

const BusinessEmail = () => {

    const becStatsResponse = useSelector((data) => data.dashboard.becStats)
    const sslExpiryDataResponse = useSelector((data) => data.dashboard.sslExpiryData)

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const [becLoading, setBecLoading] = useState(false)
    const [sslExpiryLoading, setSSlExpiryLoading] = useState(false)

    const fetchBecData = useCallback(()=>{
        setBecLoading(true)
        setSSlExpiryLoading(true)
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        dispatch(getBecData(params))       
        dispatch(getSSLExpiry(params))   
    },[organizationId, domainId, scanId, dispatch])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchBecData()
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setTriggerStatsFetch, fetchBecData]);

    useEffect(()=>{
        if(becStatsResponse !== null) {
            setBecLoading(false)
        }
    },[becStatsResponse])

    useEffect(()=>{
        if(sslExpiryDataResponse !== null) {
            setSSlExpiryLoading(false)
        }
    },[sslExpiryDataResponse])

    return (
        <>
            <Row>
                <Col lg={6}>
                    {
                        becLoading ?
                        <SkeletonLoader type={"line"} count={4} />
                        :
                        <motion.div
                            className="h-100"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="bg-white-with-shadow p-4 mt-4 h-100">
                                <div className="d-flex justify-content-between mb-2 dashboard-box-container">
                                    <p className="heading font-bold">Business Email Compromise (BEC) (Domain Organization) </p>
                                    {/* <p className="view-all"><img src={move} alt="search" className="position-absolute search-icon" /></p> */}
                                </div>
                                { becStatsResponse?.status === "failed" || becStatsResponse === "Not Found" ?
                                        <NoDataFound noDataText={becStatsResponse?.description} />
                                    :
                                    <>
                                        <div className="Business-container rounded p-1 mt-4">
                                            <div className="d-flex justify-content-between gap-3">
                                                <div className={`${becStatsResponse?.stats?.dmarc?.passed > 50 ? "box-green" : "box-orange"} rounded p-4`}>
                                                    <p className="dmarc">DMARC</p>
                                                    <h4 className='mt-3'>{becStatsResponse?.stats?.dmarc?.passed || 0}% Passed</h4>
                                                    <p className='domain'>Domain-based Message <br />Authentication</p>
                                                </div>
                                                <div className={`${becStatsResponse?.stats?.spf?.passed > 50 ? "box-green" : "box-orange"} rounded p-4`}>
                                                    <p className="spf">SPF</p>
                                                    <h4 className='mt-3'>{becStatsResponse?.stats?.spf?.passed || 0}% Passed</h4>
                                                    <p className='sender'>Sender Policy Framework</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="Business-container rounded p-1">
                                            <div className="d-flex justify-content-between gap-3">
                                                <div className={`${becStatsResponse?.stats?.dkim?.passed > 50 ? "box-green" : "box-orange"} rounded p-4`}>
                                                    <p className="dmarc">DKIM</p>
                                                    <h4 className='mt-3'>{becStatsResponse?.stats?.dkim?.passed || 0}% Passed</h4>
                                                    <p className='domain'>DomainKeys Indentified Mail</p>
                                                </div>
                                                <div className={`${becStatsResponse?.stats?.bimi?.passed > 50 ? "box-green" : "box-orange"} rounded p-4`}>
                                                    <p className="spf">BIMI</p>
                                                    <h4 className='mt-3'>{becStatsResponse?.stats?.bimi?.passed || 0}% Passed</h4>
                                                    <p className='sender'>Brand Indicators For <br /> Message Indentification</p>
                                                </div>
                                            </div>
                                        </div>    
                                    </>
                                }
                            </div>
                        </motion.div>
                    }                    
                </Col>
                <Col lg={6}>
                    {
                        sslExpiryLoading ?
                        <SkeletonLoader type={"line"} count={4} />
                        :
                        <motion.div
                            className="h-100"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="bg-white-with-shadow p-4 mt-4 h-100">
                                <div className="d-flex justify-content-between mb-2 dashboard-box-container">
                                    <p className="heading font-bold">SSL Expiry (In Days)</p>
                                </div>
                                {
                                    sslExpiryDataResponse?.status === "failed" || sslExpiryDataResponse === "Not Found" ?
                                        <NoDataFound noDataText={sslExpiryDataResponse?.description}/>
                                    :

                                    <>
                                        <div className="box-orange expire align-items-center p-3 mt-4">
                                            <Row className="justify-content-between align-items-center">
                                                <Col lg={6} className="text-start">
                                                    <div>
                                                        <p className='text-expire mt-2'>{sslExpiryDataResponse?.stats?.ssl_expiry?.expired}</p>
                                                    </div>
                                                </Col>
                                                <Col lg={6} className="text-end">
                                                    <div className="cert d-flex justify-content-end gap-3">
                                                        <p className="mb-0">Expired Certificates</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="box-high expire align-items-center p-3 mt-2">
                                            <Row className="justify-content-between align-items-center">
                                                <Col lg={1}>
                                                    <p className=" mb-0">
                                                        <span>{dashboardSSLExpiry30DaysIcon()}</span>
                                                    </p>
                                                </Col>
                                                <Col lg={5} className="text-start">
                                                    <div>
                                                        <p className='text-expire mt-2'>{sslExpiryDataResponse?.stats?.ssl_expiry?.["30days"]}</p>
                                                    </div>
                                                </Col>
                                                <Col lg={6} className="text-end">
                                                    <div className="cert d-flex justify-content-end gap-3">
                                                        <p className="mb-0">  30 Days</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="box-medium expire align-items-center p-3 mt-2">
                                            <Row className="justify-content-between align-items-center">
                                                <Col lg={1}>
                                                    <p className=" mb-0">
                                                        <span>{dashboardSSLExpiry60DaysIcon()}</span>
                                                    </p>
                                                </Col>
                                                <Col lg={5} className="text-start">
                                                    <div>
                                                        <p className='text-expire mt-2'>{sslExpiryDataResponse?.stats?.ssl_expiry?.["60days"]}</p>
                                                    </div>
                                                </Col>
                                                <Col lg={6} className="text-end">
                                                    <div className="cert d-flex justify-content-end gap-3">
                                                        <p className="mb-0">60 Days</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="box-low expire align-items-center p-3 mt-2">
                                            <Row className="justify-content-between align-items-center">
                                                <Col lg={1}>
                                                    <p className=" mb-0">
                                                        <span>{dashboardSSLExpiry90DaysIcon()}</span>
                                                    </p>
                                                </Col>
                                                <Col lg={5} className="text-start">
                                                    <div>
                                                        <p className='text-expire mt-2'>{sslExpiryDataResponse?.stats?.ssl_expiry?.["90days"]}</p>
                                                    </div>
                                                </Col>
                                                <Col lg={6} className="text-end">
                                                    <div className="cert d-flex justify-content-end gap-3">
                                                        <p className="mb-0">90 Days</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </>
                                }
                            </div>
                        </motion.div>
                    }                    
                </Col>
            </Row>

        </>

    )
}


export default BusinessEmail;